// نسخة من بيانات المستخدم على الجهاز: بدونها يُطرد الموظف إلى شاشة الدخول كلما فتح التطبيق دون إنترنت.
const USER_KEY = 'offline_user';

export function saveCachedUser(user) {
  try {
    if (user) localStorage.setItem(USER_KEY, JSON.stringify(user));
  } catch {
    // التخزين ممتلئ أو محظور: يبقى العمل مع الاتصال كما هو.
  }
}

export function getCachedUser() {
  try {
    const raw = localStorage.getItem(USER_KEY);
    return raw ? JSON.parse(raw) : null;
  } catch {
    return null;
  }
}

export function clearCachedUser() {
  try {
    localStorage.removeItem(USER_KEY);
  } catch {
    // لا شيء.
  }
}

export function selectedAuctionOf(user) {
  const auctions = Array.isArray(user?.auctions) ? user.auctions : [];
  const selectedId = Number(user?.selected_auction_id || 0)
    || (auctions.length === 1 ? Number(auctions[0].id) : 0)
    || Number(user?.branch_id || 0);
  if (!selectedId) return null;
  return auctions.find((auction) => Number(auction.id) === selectedId) || { id: selectedId };
}
